import * as React from "react";

type HeadingSectionProps = {
  title: string;
  subtitle?: string;
  img?: string;
  noPadding?: boolean;
  children?: React.ReactNode;
};

export const HeadingSection = ({
  title,
  subtitle,
  img,
  noPadding,
  children,
}: HeadingSectionProps): JSX.Element => {
  if (!img) {
    return (
      <div className="px-[15%] py-[50px] bg-white">
        <h2>{title}</h2>
        {children}
      </div>
    );
  }

  return (
    <div
      className="relative h-[200px] overflow-hidden bg-[#212522] px-[10%]"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${img})`,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
      }}
    >
      <div className={noPadding ? "" : "absolute bottom-[10px] text-white"}>
        <h1 className="m-0 text-[60px] font-normal">
          {title}
          <span className="text-[18px]">{children}</span>
        </h1>

        {subtitle && <div className="text-[24px]">{subtitle}</div>}
      </div>
    </div>
  );
};
